module.exports = __webpack_public_path__ + "img/puzzle_23.95c42e58.png";